import log from 'salvo-lite/log'

let funcQueue = false

class stickyHeader {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._elemsToSkip = document.querySelectorAll('.sticky-header-skip')
        this._elemsToSkipMobile = document.querySelectorAll('.sticky-header-mobile-skip')
        this._stickied = false
        this._isMobile = false
    }

    onInit () {
        log.debug('StickyHeader', 'Initiating', this)
        this._attachDefaultEvents()
        this._offset = this.getOffset(this._elemsToSkip)
        this.createEvent()
        if (!funcQueue) {
            funcQueue = []
            this.addEvent()
        }
        log.debug('StickyHeader', 'Initiated', this)
    }

    _attachDefaultEvents () {
        this._elem.addEventListener('transitionend', e => {
            let eName = this._stickied ? 'stuck' : 'unstuck'
            let evt = new CustomEvent(`sticky-header-${eName}`)
            document.body.dispatchEvent(evt)
        }, false)
    }

    addEvent () {
        this._elem.addEventListener('sticky-header', e => {
            for (let func of funcQueue) {
                func(e)
            }
        })
    }

    createEvent () {
        let evt = new CustomEvent('sticky-header')
        document.addEventListener('scroll', e => this.checkTop(evt))
        window.addEventListener('load', e => this.checkTop(evt))
    }

    checkTop (evt) {
        let docTop = window.pageYOffset
        if (window.innerWidth <= 480 && !this._isMobile) {
            this._offset += this.getOffset(this._elemsToSkipMobile)
            this._isMobile = true
        }
        if (window.innerWidth > 480 && this._isMobile) {
            this._offset = this.getOffset(this._elemsToSkip)
            this._isMobile = false
        }
        if (docTop >= this._offset && !this._stickied) {
            this._stickied = true
            evt.hit = this._stickied
            document.body.dispatchEvent(evt)
            this._elem.dispatchEvent(evt)
        } else if (docTop <= this._offset && this._stickied) {
            this._stickied = false
            evt.hit = this._stickied
            document.body.dispatchEvent(evt)
            this._elem.dispatchEvent(evt)
        }
    }

    getOffset (elems) {
        log.debug('StickyHeader', 'Getting offset')
        let retOffset = 0
        for (let elem of elems) {
            log.debug('StickyHeader', 'Adding height')
            retOffset += elem.offsetHeight
            log.debug('StickyHeader', 'Height added')
        }
        return retOffset
    }
}

export default stickyHeader

export function addToQueue (func) {
    funcQueue.push(func)
    return funcQueue
}



// WEBPACK FOOTER //
// ./src/scripts/components/header/StickyHeader.js